// @flow
import '~/assets/stylesheets/index.css'; // <--- Make sure this stays first
import 'velocity-animate';
import 'velocity-animate/velocity.ui';

import * as React from 'react';

import { auth as authApi } from '~/core/api';
import configureStore from '~/core/state/store';
import Cookie from '<drivers>/cookie';
import { logIn } from '~/core/state/application/actions';
import moment from 'moment-timezone';
import queryString from 'query-string';
import ReactDOM from 'react-dom';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import Root from '~/root';
import { getFeatureFlag } from '~/core/state/config/selectors';

const FLST_PATH = '/flst/auth/apilogin/api/';

export async function run() {
    configureMoment();

    const store = configureStore();
    const token = getToken();

    if (token) {
        await initialiseSession(token, store);
    }

    // This starts the 300ms fade for the splash screen
    const hiveLogo = document.querySelector('.hive-logo');

    if (hiveLogo !== null) {
        hiveLogo.setAttribute('class', 'hive-logo hive-logo--fade-out');
        hiveLogo.addEventListener('transitionend', () => renderApp(store));
    } else {
        renderApp(store);
    }

    unregisterServiceWorker();
}

async function initialiseSession(token, store) {
    try {
        // This is a short-term hack for now. Once we upgrade to React Router v4
        // we can bring this into a component/container and not render routes until
        // login has been completed.

        const state = store.getState();
        const multiHomeEnabled = getFeatureFlag(state, 'multiHome');
        const response = await authApi.adminLogin(token, multiHomeEnabled).then(res => res.json());
        const deviceGroupsEnabled = getFeatureFlag(state, 'deviceGroups');

        store.dispatch(logIn({ ...response, deviceGroupsEnabled, token }));
    } catch (err) {
        Cookie.remove('token');
        Cookie.remove('endpoint');
    }
}

function getToken() {
    // mobile apps supply token via query params
    const { token: queryToken } = queryString.parse(global.location.search);
    // preferred method is to supply token via url fragment, SSO supplies token as id_token
    const { token: hashToken, id_token: ssoToken } = queryString.parse(global.location.hash);
    // FLST can supply token as a path parameter (deprecated)
    const pathToken =
        global.location.pathname.indexOf(FLST_PATH) === 0
            ? global.location.pathname.substr(global.location.pathname.lastIndexOf('/') + 1)
            : undefined;

    return ssoToken || hashToken || queryToken || pathToken || Cookie.get('token');
}

function configureMoment() {
    moment.relativeTimeThreshold('s', 59);
    moment.relativeTimeThreshold('m', 59);
    moment.relativeTimeThreshold('h', 23);
}

function renderApp(store) {
    ReactDOM.render(<Root store={store} />, document.getElementById('app'));
}



// WEBPACK FOOTER //
// ./src/app.js